import { call, put } from "redux-saga/effects";
import { requestGetVinFromImage } from "../requests/vinImage";
import { setVinFromImage } from "../../entities/vinImage";

export function* handleGetVinFromImage(_action) {
    try {
        const response = yield call(requestGetVinFromImage);
        const { data } = response;
        yield put(setVinFromImage({ ...data }));
    } catch (error) {
        console.log(error);
    };
};
